function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
import * as c from '../constants';
var initialState = {
  entities: {},
  pages: {
    1: {
      ids: []
    }
  },
  pagination: {},
  status: {
    fetching: true,
    loaded: false,
    savingEmailNotificationSettings: false,
    savingCertificate: false,
    savingTouchup: false
  }
};
var pages = function pages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.pages;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.ORDERS_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.pagination.page, {
        ids: action.orderIds,
        fetching: false
      }));
    default:
      return state;
  }
};
var entities = function entities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.entities;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.ORDERS_LOADED:
      return _.merge({}, state, action.orders);
    case c.CERTIFICATE_UPDATED:
      return !action.certificate ? state : _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.certificate.externalId, _objectSpread(_objectSpread({}, state[action.certificate.externalId]), {}, {
        certificate: action.certificate
      })));
    case c.ORDER_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.order.externalId, _objectSpread(_objectSpread({}, state[action.order.externalId]), {}, {
        deadline: action.order.deadline,
        journal: _objectSpread(_objectSpread(_objectSpread({}, state[action.order.externalId].journal || {}), action.order.journal || {}), {}, {
          valid: true
        }),
        services: action.order.services,
        styleOfEnglish: action.order.styleOfEnglish,
        title: action.order.title
      })));
    case c.ORDER_PAYMENT_INFORMATION_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.order.externalId, _objectSpread(_objectSpread({}, state[action.order.externalId]), {}, {
        freeOrder: action.order.freeOrder
      })));
    case c.DOWNLOAD_URL_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.externalId, _objectSpread(_objectSpread({}, state[action.externalId]), {}, {
        downloadPercentage: 0,
        retrievingDownload: true
      })));
    case c.DOWNLOAD_URL_REQUEST_PROGRESS:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.externalId, _objectSpread(_objectSpread({}, state[action.externalId]), {}, {
        downloadPercentage: action.percent
      })));
    case c.DOWNLOAD_URL_REQUEST_COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.externalId, _objectSpread(_objectSpread({}, state[action.externalId]), {}, {
        retrievingDownload: false
      })));
    case c.SERVICES_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.externalId, _objectSpread(_objectSpread({}, state[action.externalId]), {}, {
        serviceOptions: action.serviceOptions
      })));
    default:
      return state;
  }
};
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.ORDERS_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        loaded: true
      });
    case c.ORDERS_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: true
      });
    case c.CERTIFICATE_UPDATE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingCertificate: true
      });
    case c.CERTIFICATE_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingCertificate: false
      });
    case c.EMAIL_NOTIFICATION_UPDATE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingEmailNotificationSettings: true
      });
    case c.EMAIL_NOTIFICATION_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingEmailNotificationSettings: false
      });
    default:
      return state;
  }
};
export var ordersReducer = function ordersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.CERTIFICATE_UPDATE_REQUESTED:
    case c.ORDERS_REQUESTED:
    case c.EMAIL_NOTIFICATION_UPDATE_REQUESTED:
    case c.EMAIL_NOTIFICATION_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    case c.CERTIFICATE_UPDATED:
    case c.ORDER_PAYMENT_INFORMATION_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action),
        entities: entities(state.entities, action)
      });
    case c.DOWNLOAD_URL_REQUESTED:
    case c.DOWNLOAD_URL_REQUEST_COMPLETE:
    case c.DOWNLOAD_URL_REQUEST_PROGRESS:
    case c.SERVICES_LOADED:
    case c.ORDER_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        entities: entities(state.entities, action)
      });
    case c.ORDERS_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        pages: pages(state.pages, action),
        pagination: action.pagination,
        entities: entities(state.entities, action),
        status: status(state.status, action)
      });
    default:
      return state;
  }
};
export default ordersReducer;